import type { spades } from "@app/rules";
import type { ToastData } from "../components/Toast";
import type { T } from "./tableText";
import { teamsLine, toneOf } from "./toastParts";

/** Spades in words: the seat line and the hand-end toast. */

export function spadesSeatSub(
  view: spades.SpadesView,
  seat: number,
  yourSeat: number | null,
  t: T,
): string {
  const bid = view.bids[seat] ?? null;
  const deciding = view.turn === seat && view.phase === "bidding";
  if (deciding) return seat === yourSeat ? t("table.bid.you") : t("table.seat.thinking");
  if (bid === null) return t("table.seat.waiting");
  const bidText = bid === 0 ? t("spades.seat.nil") : t("spades.seat.bid", { amount: bid });
  return `${bidText} · ${t("table.seat.tricks", { tricks: view.tricksWon[seat] ?? 0 })}`;
}

/** Spades: the team deltas, then your team's bid, tricks and bags. */
export function spadesHandEnd(view: spades.SpadesView, t: T): ToastData | null {
  const result = view.lastHandResult;
  if (result === null) return null;
  const mine = result.teams[view.yourSeat % 2 === 0 ? 0 : 1];
  return {
    title: teamsLine(
      result.teams.map((team) => team.delta),
      view.yourSeat,
      t,
    ),
    sub: t("spades.toast.team", { bid: mine.bid, tricks: mine.tricks, bags: mine.bags }),
    tone: toneOf(mine.delta),
  };
}
